export class Productlanguage{
    ProductCode: string;
    Languages: string[];

    constructor(productCode: string, languages: string[]) {
        this.ProductCode = productCode;
        this.Languages = languages;
    }
}

export enum Languages{
    "it-IT" = "ITALIAN",
    "en-US" = "ENGLISH",
    "pt-BR" = "PORTUGUESE"
}